import { render, staticRenderFns } from "./BackToTop.component.vue?vue&type=template&id=1eb5fe1d&scoped=true&"
import script from "./BackToTop.component.vue?vue&type=script&lang=ts&"
export * from "./BackToTop.component.vue?vue&type=script&lang=ts&"
import style0 from "@/scss/components/back-to-top/_back-to-top.scss?vue&type=style&index=0&id=1eb5fe1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb5fe1d",
  null
  
)

export default component.exports